import React from 'react';
import { View, FlatList, RefreshControl, Text } from 'react-native';

import Colors from "../../constants/Colors";
import get from "../../api/methods/get";
import {QUERY_REVIEWS_BY_DELIVERABLE} from "./api/deliveryEndpoints";
import {Card, ConditionalTextRender, SpinnerControl} from "../../components";
import ReviewRender from "./ReviewRender";
import queryString from "query-string";
import NavBar from "../../components/NavBar";

/*  DeliverableReviewsScreen
    Lista de render dos componentes de Review enviado pelo usuário
 */

class DeliverableReviewsScreen extends React.Component {

    state = {
        isFetching: false,
        reviews: []
    }

    fetchReviews = async () => {
        if (this.state.isFetching) return;
        this.setState({ isFetching: true });

        try {
            const values = queryString.parse(this.props.location.search);
            const deliverableId = values.deliverableId;
            let result = await get(QUERY_REVIEWS_BY_DELIVERABLE(deliverableId));
            let json = await result.json();

            this.setState({ reviews: json.data.Items });

        } catch (e) {
            console.log(e);
        }

        this.setState({ isFetching: false });
    }

    componentDidMount() {
        this.fetchReviews();
    }

    render() {
        return (
            <NavBar title={"Reviews"}>

                <SpinnerControl
                    isFetching={this.state.isFetching}
                    text={"Carregando reviews!"}
                />

                {
                    (this.state.isFetching === false && this.state.reviews.length === 0) &&
                        <Text style={{ fontSize: 16, textAlign: 'center', color: Colors.fontColorOnBackground, margin: 20 }}>
                            {"Ainda não recebemos nenhuma revisão da sua aplicação, assim que alguém enviar iremos te avisar!"}
                        </Text>
                }

                <FlatList
                    contentContainerStyle={{ width: 400 }}
                    data={this.state.reviews}
                    renderItem={({item, index}) => {

                        const isLast = index === this.state.reviews.length - 1;

                        return (
                            <ReviewRender
                                {...item}
                                isLast={isLast}
                            />
                        )
                    }}
                    refreshControl={
                        <RefreshControl
                            refreshing={this.state.isFetching}
                            onRefresh={() => this.fetchReviews()}
                            colors={[Colors.spinnerColor]}
                            title={"Carregando reviews!"}
                        />
                    }
                />

            </NavBar>
        )
    }

}

export default DeliverableReviewsScreen;
